<template>
  <div class="container">
    <div class="top-address">
      <div class="flex-send-receive">
        <img class="icon-send-receive" src="../../../static/images/express/send-to.png">
        <div class="flex-send-receive-info">
          <span class="address-type">寄出地址</span>
          <span>{{caceFilingAddress}}</span>
        </div>
      </div>
      <div class="top-address-time">
        <span>提交时间：</span>
        <span>{{submitDate}}</span>
      </div>
      <div class="flex-send-receive">
        <img class="icon-send-receive" src="../../../static/images/express/to-receive.png">
        <div class="flex-send-receive-info">
          <span class="address-type">送达地址</span>
          <span>{{deliveryAddress}}</span>
        </div>
      </div>
    </div>
    <div class="trajectory-info">
      <div class="trajectory-name">
        <img src="../../../static/images/express/trajectory.png"></img>
        <span>物流轨迹</span>
      </div>
      <el-divider></el-divider>
      <div v-if="logisticsList && logisticsList.length > 0" class="logistics-info">
        <el-timeline :reverse="reverse">
          <el-timeline-item placement="top"
                            v-for="(activity, index) in logisticsList"
                            :key="index"
                            :size="index == logisticsList.length-1?'large':'normal'"
                            :type="index == logisticsList.length-1?'primary':'normal'"
                            :timestamp="activity.opName">
            <div class="timeline-info">
              <span class="timeline-info-address">{{activity.opDesc}}</span>
              <span class="timeline-info-time">{{activity.opTime}}</span>
            </div>
          </el-timeline-item>
        </el-timeline>
      </div>
      <div v-else class="logistics-list">
        <img class="no-logistics-img" src="../../../static/images/express/no-logistics.png"></img>
        <span class="no-logistics-msg">暂无物流信息~</span>
      </div>
    </div>
  </div>
</template>

<script>
  import axios from 'axios'
  import {getFullUrl} from '@api/center/server'
  import { isNull } from '@/utils/common'
  import CryptoJS from 'crypto-js/crypto-js'
  import {getServerUrl} from '@api/center/hostinfo'
  export default {
    name: 'logistics-info',
    data() {
      return {
        reverse: true,
        caceFilingAddress: '',
        deliveryAddress: '',
        submitDate: '',
        logisticsList: [],
        logisticsId: '',
        ip: '',
        suitNo: ''
      }
    },
    created() {

      if (isNull(this.$route.query.logisticsId)) {
        this.$message.error('未获取到物流订单ID,请重新扫码')
        return
      }
      this.logisticsId = this.$route.query.logisticsId
      /*if (isNull(this.$route.query.ip)) {
        this.$message.error('未获取到IP地址,请重新扫码')
        return
      }*/
    if (isNull(this.$route.query.suitNo)) {
        this.$message.error('未获取到主机编号,请重新扫码')
        return
    }
      /*this.ip = this.$route.query.ip*/
      this.suitNo = this.$route.query.suitNo
      this.init()
    },
    methods: {
      init: function() {
        let self = this
        let suitNo = this.suitNo
          getServerUrl(suitNo).then(data => {
          let fullUrl = data.result
          if ('' === fullUrl) {
            self.$message.error('ip有误，请联系管理员')
            return;
          }

          // 获取物流轨迹
          axios.defaults.timeout = 15000
          axios({
            url: self.getLogisticsFullUrl(fullUrl),
            method: 'get'
          }).then(data => {
              if (data.data.code === 100){
                  this.$message.error(data.data.message)
                  return;
              }else if (data.data.code !== 200){
                  this.$message.error("获取轨迹失败，请稍后重试")
                  return;
              }
            let result = data.data.result
            self.caceFilingAddress = result.caceFilingAddress
            self.deliveryAddress = result.deliveryAddress
            self.submitDate = result.submitDate
            self.logisticsList = result.postalTrajectoryResultParamList
          }).catch(err => {
            this.$message.error("获取轨迹失败，请稍后重试")
          })
        })
      },

      /**
       * 查询物流的url
       * @param fullUrl
       * @returns {*}
       */
      getLogisticsFullUrl(fullUrl){
        let signKey = process.env.APP_KEY
        let SECRET = process.env.APP_SCREAT

        fullUrl += '/151/app/global/ems/queryLogisticsTrajectory/' + this.logisticsId;
        fullUrl += "?timestamp=" + new Date().getTime()
        fullUrl += "&key=" + (signKey ? signKey : "")

        // 格式化url
        var requestURI = this.nthIndexOf(fullUrl.split("?")[0], "/", 3)
        requestURI = fullUrl.startsWith("/") ? requestURI : "/" + requestURI
        requestURI = fullUrl.endsWith("/") ? requestURI.substring(0, requestURI.length - 1) : requestURI

        // 请求参数
        var args = new Array()
        var query = fullUrl.split("?")[1]
        var pairs = query.split("&")
        for (var i = 0; i < pairs.length; i++) {
          var pos = pairs[i].indexOf('=')
          if (pos == -1) continue
          var argname = pairs[i].substring(0, pos)
          var value = pairs[i].substring(pos + 1)
          value = decodeURIComponent(value)
          var arg = new Object()
          arg.key = argname
          arg.value = value
          args.push(arg)
        }
        args = args.sort(function (a, b) {
          return a.key > b.key ? 1 : -1
        })
        var paramstring = ""
        for (var index in args) {
          paramstring += args[index].key + args[index].value
        }

        // 加密
        var sign = CryptoJS.HmacMD5(requestURI + paramstring, SECRET)
        fullUrl = fullUrl + "&sign=" + sign

        return fullUrl;
      },

      nthIndexOf(str, c, n) {
        let index = -1
        if (n <= 0) {
          return ""
        }
        for(let i=0; i<n; i++) {
          index = str.indexOf(c)
          if (index == -1) {
            return ""
          } else {
            str = str.substring(index+1)
          }
        }
        return str
      },
    }
  }
</script>

<style scoped>
  .container{
    width: 100vw;
    min-height: 100vh;
    background-color: #f2f2f2;
    padding: 10px;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .top-address{
    width: 92%;
    background-color: #FFFFFF;
    padding: 20px 10px;
    border-radius: 8px;
    font-size: 14px;
  }

  .icon-send-receive{
    width: 28px;
    height: 28px;
    margin-right: 13px;
  }

  .flex-send-receive{
    display: flex;
    justify-content: flex-start;
    align-items: center;
  }

  .top-address-time{
    margin: 9px 0 20px 41px;
    color: #898989;
  }

  .flex-send-receive-info{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
  }

  .address-type{
    margin-bottom: 4px;
  }

  .trajectory-info{
    margin-top: 10px;
    width: 92%;
    background-color: #FFFFFF;
    border-radius: 8px;
    padding: 20px 0;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .trajectory-name{
    font-size: 15px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: 10px;
  }

  .trajectory-name img{
    width: 18.5px;
    height: 16px;
    margin-right: 6px;
  }

  .trajectory-info .el-divider--horizontal{
    margin: 10px 0;
    background-color: #DCDCDC;
  }

  .logistics-list{
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .logistics-list .no-logistics-img{
    width: 174px;
    height: 173px;
    margin-top: 83px;
  }

  .logistics-list .no-logistics-msg{
    color: #000000;
    font-size: 14px;
    margin-bottom: 95px;
    margin-top: 13px;
  }

  .logistics-info{
    padding: 0 20px 0 10px;
    margin-top: 5px;
  }

  .timeline-info{
    display: flex;
    flex-direction: column;
    align-items: flex-start;
  }

  .timeline-info-address{
    font-size: 15px;
    color: #808080;
    margin-bottom: 9px;
  }

  .timeline-info-time{
    font-size: 12px;
    color: #808080;
  }

  .logistics-info >>>.el-timeline-item__timestamp{
    color: #4D4D4D;
  }
</style>



// WEBPACK FOOTER //
// src/view/mobile/logistics-info.vue